import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';

import { MainListViewComponent } from '../main-listview/main-listview.component';
import { TableListGridProviderDirective } from '../table-list-grid/directives/table-list-grid-provider.directive';
import { ActivatedRoute } from '@angular/router';
import { DeduplikacijaAttributeStateService } from '@app/shared/services/agent-selection-provider.service';

@Component({
  selector: 'app-agent-prikaz',
  templateUrl: './agent-prikaz.component.html',
  styleUrls: ['./agent-prikaz.component.scss'],
  providers: [DeduplikacijaAttributeStateService]
})
export class AgentPrikazComponent
  extends MainListViewComponent
  implements OnInit, AfterViewInit
{
  constructor(
    protected override route: ActivatedRoute,
    private deduplikacijaAttributeStateService: DeduplikacijaAttributeStateService
  ) {
    super(route);
  }

  override INIT_COMP_ID = EarhivUiComponents.COMMON_TABLE_LIST_GRID_VIEW;
  @ViewChild(TableListGridProviderDirective)
  listViewProvider!: TableListGridProviderDirective;
  override ngOnInit() {
    this.changeView('agent');
  }

  ngAfterViewInit() {
    this.listViewProvider.selectedItems$.subscribe((selectedItems) => {
      this.deduplikacijaAttributeStateService.setSelectedAgents(selectedItems);
    });
  }

  tablica = [
    'en~agent~naziv',
    'en~agent~vrsta_agenta',
    'en~agent~podvrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~vrijeme_djelovanja_labela',
    'en~agent~status',
    'en~agent~status_obrade_id',
    'en~agent~date_modified'
  ];

  lista = [
    'en~agent~identifikator',
    'en~agent~naziv',
    'en~agent~content_id',
    'en~agent~vrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~status',
    'en~agent~povijest',
    'en~agent~glavni_identifikator'
  ];

  grid = [
    'en~agent~identifikator',
    'en~agent~naziv',
    'en~agent~content_id',
    'en~agent~vrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~status'
  ];
}
